import { getCustomersRequest, getAllCustomersRequest, getCustomerByNumberRequest } from '../requests';
import { throttle } from '@/core';

async function getCustomerByNumber({ state, commit }, customerNo) {
	let customer = state.customers.find(customer => customer.customerNo === customerNo);
	if (customer) return customer;
	try {
		customer = await getCustomerByNumberRequest(customerNo);
		commit('setCustomers', [...state.customers, customer]);
		return customer;
	} catch (err) {
		console.error(`Get customer by number failed: ${err}`);
		return false;
	}
}

async function getCustomers({ commit }, filterString) {
	let response = [];
	try {
		response = await getCustomersRequest({ filterString });
	} catch (err) {
		console.error(`Get customers failed: ${err}`);
		throw err;
	}
	commit('setCustomers', response);
	return response;
}

async function getAllCustomers({ state, commit }) {
	try {
		if (state.customers.length === 0) {
			await fetchCustomers();
		} else {
			await throttle(fetchCustomers, 'getCustomers', 60 * 1000);
		}
	} catch (err) {
		console.error(`Get all customers failed: ${err}`);
		throw err;
	}

	async function fetchCustomers() {
		let response = await getAllCustomersRequest();
		commit('setCustomers', response);
	}
}

export default { getCustomers, getAllCustomers, getCustomerByNumber };
